import React from "react";
import Navbar from "../../components/layout/Navbar";

const Page404 = () => {
  return (
    <>
      <Navbar />
      <div className="page404">
        <div className="page404__container">
          <div className="page404__container__content">
            <img
              src="assets/images/404.png"
              alt="404 page"
              className="page404__container__content__image"
            />
            <h3 className="page404__container__content__heading">
              Looks like you are lost.
            </h3>
            <p className="page404__container__content__paragraph">
              It's okay you can always go back to your home.
            </p>
            <a href="/">
              <button className="btn btn-md page404__container__content__button">
                Take me to the home
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page404;
